import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  ViewChildren,
  ChangeDetectorRef,
} from '@angular/core';

import { SelectItem, LazyLoadEvent } from 'primeng';
import { IPageResult } from '../../interfaces/page-result';
import { IPostcodeWeight } from '../../interfaces/postcode-weight';
import { IPostcodeWeightFilter } from '../../interfaces/postcode-weight-filter';
import { PostcodeWeightService } from '../../services';
import { ConfirmationService } from 'primeng';
import { InputHelper } from '../../utils/input.helper';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import FileSaver from 'file-saver';

@Component({
  selector: 'manage-postcodes-weight',
  templateUrl: './manage-postcodes-weight.component.html',
  styleUrls: ['./manage-postcodes-weight.component.scss'],
})
export class ManagePostcodesWeightComponent implements OnInit {
  @Input() isPricingAdmin: boolean;
  public backTo: string;
  public isActiveCheckList: boolean = false;

  public page: IPageResult<IPostcodeWeight> = {
    items: [],
    total: 0,
  };
  public selectedItem: any;

  public event: any;
  public filter: Subject<IPostcodeWeightFilter>;
  public filterVal: IPostcodeWeightFilter;
  public isLoaded: boolean = false;
  public filterString: string;

  public showAddPostcodeDlg: boolean = false;
  public pItem: IPostcodeWeight = { id: 0 };
  public selectedWeight: any;
  public showDeletePostcodeDlg: boolean = false;
  public showProgressBar: boolean = false;
  private reportSubscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private postcodeWeightService: PostcodeWeightService,
    private changeDetector: ChangeDetectorRef,
    public inputHelper: InputHelper,
    private confirmationService: ConfirmationService,
    public messageService: MessageService,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.initDefaultFilter();

    this.filter = new Subject<IPostcodeWeightFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);
  }

  load(filter: IPostcodeWeightFilter) {
    this.postcodeWeightService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 100,
      sortField: 'postcode',
      sortOrder: 1,
      filters: {
        postcode: {},
      },
    };
  }

  clearFilter() {
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  addPostcodeWeight() {
    this.pItem = {
      id: 0,
      customerWeight: 1,
      supplierWeight: 1,
    };
    this.showAddPostcodeDlg = true;
  }

  savePostcodeWeight(item) {
    this.postcodeWeightService
      .save(item)
      .then((x) => {
        this.filter.next(this.filterVal);
        this.showAddPostcodeDlg = false;
      })
      .catch((res) => {
        this.messageService.add(Message.Error('Postcode already exists in DB.', 'Postcode exists'));
      });
  }

  cellEdit(item) {
    console.log('Saving weight item: ', item);

    if (
      item.customerWeight.toString().trim() == '' ||
      item.supplierWeight.toString().trim() == '' ||
      item.customerWeightFixedPickup.toString().trim() == '' ||
      item.supplierWeightFixedPickup.toString().trim() == '' ||
      item.customerWeightFixedDropoff.toString().trim() == '' ||
      item.supplierWeightFixedDropoff.toString().trim() == ''
    ) {
      this.messageService.add(
        Message.Error('Customer and Supplier weightings cannot be empty', 'Error'),
      );
      this.filter.next(this.filterVal);
      return;
    }

    this.postcodeWeightService
      .save(item)
      .then((x) => {
        item.customerWeight = x.customerWeight;
        item.supplierWeight = x.supplierWeight;
        item.customerWeightFixedPickup = x.customerWeightFixedPickup;
        item.supplierWeightFixedPickup = x.supplierWeightFixedPickup;
        item.customerWeightFixedDropff = x.customerWeightFixedDropoff;
        item.supplierWeightFixedDropoff = x.supplierWeightFixedDropoff;
        item.postcode = x.postcode;
        item.comments = x.comments;
        item.updatedByUserName = x.updatedByUserName;
        item.updatedOn = x.updatedOn;
      })
      .catch((res) => {
        console.log(res);
      });
  }

  deleteWeight() {
    this.showDeletePostcodeDlg = true;
  }

  deleteWeightConfirm(item) {
    this.postcodeWeightService.deleteWeight(item).then((x) => {
      this.load(this.filterVal);
      this.showDeletePostcodeDlg = false;
    });
  }

  onRowClick(item: any) {
    this.selectedWeight = item;
  }

  fixDigits(item) {
    if (item.customerWeight < 1) item.customerWeight = 1;
    if (item.customerWeight > 10) item.customerWeight = 10;

    if (item.supplierWeight < 1) item.supplierWeight = 1;
    if (item.supplierWeight > 10) item.supplierWeight = 10;
  }

  onRatecardPriceKeyDown(e, data, col) {
    if (this.inputHelper.allowNumberInputKey(e)) {
      if (e.which == 9 || e.which == 13 || e.which == 27) {
        var newValue = this.correctPriceOnBlur(e.currentTarget);
        data.pricing[col.field] = Number(newValue);

        //this.stopCellEditingCards(e);
      }
    }
  }

  onRatecardPriceChange(e, data, col) {
    console.log('onRatecardPriceChange', e.srcElement.value);
  }

  stopCellEditingBandings(e) {
    if (e.which == 9 || e.which == 13) {
      //prevent form submit
      if (e.which == 13) e.preventDefault();
      //this.dtBandings.switchCellToViewMode(this.dtBandings.editingCell);
      // this.dtBandings.moveToNextCell(e);
    }
  }

  to2Digits(v) {
    return (Math.round(v * 100) / 100).toFixed(2);
  }

  correctPriceOnBlur(target) {
    var maxValue = 10;
    var maxDigits = 2;

    var v = target.value;
    if (v > maxValue) {
      res = maxValue.toString();
    } else {
      var a = v.split('.');

      var res = '';
      if (a.length > 0) {
        if (a[0] > maxValue) {
          res = maxValue.toString();
        } else {
          if (a.length > 1 && a[1].length > maxDigits) a[1] = a[1].substring(0, maxDigits);

          res = (a[0] ? a[0] : '0') + (a.length > 1 && a[1] > 0 ? '.' + a[1] : '');
        }
      }

      if (res == '') res = '0';
    }

    target.value = res;
    return res;
  }

  //onRatecardCellBlur(e, data, col) {
  //    var newValue = this.correctPriceOnBlur(e.currentTarget);

  //    data.pricing[col.field] = Number(newValue);

  //    console.log('corrected price', data.pricing[col.field]);
  //}

  onBandingCellBlur(e, data, col) {
    var newValue = this.correctPriceOnBlur(e.currentTarget);
    data.price = newValue;
  }

  download() {
    this.showProgressBar = true;
    this.reportSubscription = this.postcodeWeightService
      .downloadPostCodeWeighing(this.filterVal)
      .subscribe(
        (res) => {
          this.showProgressBar = false;
          this.messageService.add(
            Message.Success('Download successful. Please check your download folder.'),
          );
          this.handleDownloadFile(res);
        },
        (error) => {
          this.messageService.add(Message.Error('Unable to download the report.'));
        },
        () => {},
      );
  }

  handleDownloadFile(blob) {
    FileSaver.saveAs(blob, 'Postcode Weighing.csv');
  }

  ngOnDestroy() {
    if (this.reportSubscription) this.reportSubscription.unsubscribe();
  }
}
